import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import TagManager from "react-gtm-module";
// eslint-disable-next-line
import i18n from "./i18n";

const tagManagerArgs = { gtmId: process.env.REACT_APP_GOOGLE_ANALYTICS_GTM_ID || "" };
if (tagManagerArgs.gtmId && tagManagerArgs.gtmId != "GTM-000000") {
  TagManager.initialize(tagManagerArgs);
  console.log("Google analytics enabled");
} else {
  console.log("Google analytics disabled");
}

ReactDOM.render(
  <Suspense fallback={"Loading localizations"}>
    <App />
  </Suspense>,
  document.getElementById("root")
);
